module.exports = __webpack_public_path__ + "img/agentproc.138d2aa3.svg";